import { Link } from 'react-router-dom';
import { articlesList } from '@/mocks/categories';

export default function ArticleCards() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            VigorBuy Spreadsheet Guides &amp; Resources
          </h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            Explore our in-depth articles, comparisons, and expert guides to master VigorBuy Spreadsheet
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articlesList.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all hover:scale-[1.02] cursor-pointer flex flex-col"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-900 group-hover:text-primary-600 transition-colors mb-2 leading-snug">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed flex-1">
                  {article.excerpt}
                </p>
                <div className="mt-3 flex items-center gap-1.5 text-xs font-medium text-primary-500">
                  <span>Read Article</span>
                  <i className="ri-arrow-right-line text-xs"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}